import React from "react";

interface TranslationProgressBarProps {
  initial: number;
  pending: number;
}

const TranslationProgressBar: React.FC<TranslationProgressBarProps> = ({ initial, pending }) => {
  const translatedFromInitial = initial - pending;
  const progressPercentage = initial > 0 ? (translatedFromInitial / initial) * 100 : 0;

  return (
    <div className="flex flex-col justify-center gap-1 min-w-[140px] items-center">
      <div className="w-full bg-gray-200 rounded-full h-3 shadow-inner">
        <div
          className="bg-gradient-to-r from-teal-400 via-green-400 to-green-500 h-3 rounded-full transition-all duration-500 ease-out shadow-sm"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <span className="text-sm font-semibold text-gray-700">{progressPercentage.toFixed(1)}% Complete</span>
    </div>
  );
};

export default TranslationProgressBar;
